export default class App
{
    constructor() {
        this.options = () => {
            let metas = document.getElementsByTagName('meta');

            let metaValues = {
                'sg:domain': 'www.strom-guenstiger.de',
                'sg:local':  0
            };
            let metaKeys = Object.keys(metaValues);

            for (let i = 0; i < metas.length; i++) {
                let prop = metas[i].getAttribute('property');

                if (metaKeys.indexOf(prop) >= 0) {
                    metaValues[prop] = metas[i].getAttribute('content');
                }
            }

            return metaValues;
        };

        this.config = {
            domain:  this.getOption('sg:domain'),
            isLocal: this.isLocal(),
            appPath: '',
        };
    }

    /**
     * @return {boolean}
     */
    isLocal() {
        return this.getOption('sg:local') === '1';
    }

    /**
     * @param option
     */
    getOption(option) {
        return this.options()[option];
    }
}
